<template>
  <Accordion>
    <AccordionTab>
      <template #header>
        <span style="padding-left: 10px;">
        <span>Search</span>
        </span>
      </template>
      <span style="min-width: 25rem;">
    <span class="p-field p-mt-5">
    <label for="name"
           style="color: #6c757d; margin-top: 10px; margin-bottom: 1px; margin-left: 5px;">{{
        _t('label_name')
      }}</label>
      <div class="p-pb-0"/>
     <span class="p-input-icon-right">
            <i class="pi pi-search"/>
            <InputText id="name" v-model="participantMultiFilter.name" style="width: 24rem;" type="text"/>

     </span>
          <div class="p-pb-3"/>
    </span>
        <span class="p-field p-mt-5">
    <label for="surname"
           style="color: #6c757d; margin-top: 10px; margin-bottom: 1px; margin-left: 5px;">{{
        _t('label_surname')
      }}</label>
      <div class="p-pb-0"/>
     <span class="p-input-icon-right">
            <i class="pi pi-search"/>
            <InputText id="surname" v-model="participantMultiFilter.surname" style="width: 24rem;" type="text"/>

     </span>
    </span>
        <div class="p-pb-3"/>
    <span class="p-field p-mt-5">
    <label for="shortname"
           style="color: #6c757d; margin-top: 10px; margin-bottom: 1px; margin-left: 5px;">{{
        _t('label_short_name')
      }}</label>
      <div class="p-pb-0"/>
     <span class="p-input-icon-right">
            <i class="pi pi-search"/>
            <InputText id="shortname" v-model="participantMultiFilter.shortname" style="width: 24rem;" type="text"/>

     </span>
              <div class="p-pb-3"/>
    </span>
    <span class="p-field p-mt-5">
    <label for="lang"
           style="color: #6c757d; margin-top: 10px; margin-bottom: 1px; margin-left: 5px;">
      {{
        _t('label_language')
      }}
    </label>
            <div class="p-pb-0"/>
       <Dropdown id="lang" v-model="participantMultiFilter.language"
                 :options="availableLanguages"
                 :placeholder="_t('label_language')"
                 :showClear="true"
                 optionLabel="label"
                 optionValue="value"
                 style="width: 24rem;"
       />
    </span>
    <div class="p-pb-3"/>
    <span class="p-field p-mt-5">
      <label for="device"
             style="color: #6c757d; margin-top: 10px; margin-bottom: 1px; margin-left: 5px;"
      >
        {{
          _t('DEVICE_GROUP')
        }}
      </label>
            <div class="p-pb-0"/>
      <Dropdown
          id="device"
          v-model="participantMultiFilter.device"
          :options="getDevices"
          :placeholder="_t('_NONE')"
          :showClear="true"
          class="p-p-0"
          dataKey="message"
          optionLabel="message"
          optionValue="callingDeviceType"
          style="width: 24rem;"
      />
    </span>
        </span>
      <div class="p-pb-3"/>
      <hr>
      <span class="p-field p-mt-5">
    <label for="group_name"
           style="color: #6c757d; margin-top: 10px; margin-bottom: 1px; margin-left: 5px;">{{
        _t('label_pg')
      }}</label>
      <div class="p-pb-0"/>
     <span class="p-input-icon-right">
            <i class="pi pi-search"/>
            <InputText id="shortname" v-model="participantMultiFilter.groupname" style="width: 24rem;" type="text"/>

     </span>
    </span>
    </AccordionTab>
  </Accordion>

  <div class="p-pb-3"/>
  <Tree
      ref="tree"
      v-model:selectionKeys="selectedItems"
      :filter="false"
      :filterPlaceholder="_t('filter_org_filter')"
      :loading="loading"
      :metaKeySelection="false"
      :placeholder="_t('Select')"
      :value="isRecursive ? organizations[0].children : organizations"
      filter-by="label"
      filterMode="lenient"
      selectionMode="checkbox"
      style="min-width: 24rem;"
      @nodeExpand="nodeExpand"
      @nodeSelect="nodeSelect"
      @nodeUnselect="nodeUnselect"
  >
    <template #organization="slotProps">
      <b>{{ slotProps.node.label }}</b>
    </template>
    <template #participant="slotProps">
      {{ slotProps.node.label }}
    </template>
    <template #group="slotProps">
      <span class="color-green">{{ slotProps.node.label }}</span>
    </template>
  </Tree>
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import { formatApiError } from '@/utils/apiError'
import debounce from 'lodash/debounce'
import {
  normalizeParticipantSelectorFilter,
  shouldSearchParticipantGroups,
  shouldSearchParticipants,
  shouldUseRecursiveParticipantSearch
} from "@/components/ixarma/participant-selector/participantSelectorDto";
import { createParticipantSelectorRequestGuard } from "@/components/ixarma/participant-selector/useParticipantSelectorTree";
import {
  fetchChildOrganizations,
  fetchParticipantGroups,
  fetchParticipants,
  fetchRootOrganizations
} from "@/components/ixarma/participant-selector/participantSelectorApi";

export default {
  name: 'ParticipantSelector',
  props: {
    modelValue: {
      type: null,
      default: null,
    },
    orgId: {
      type: [Number, String],
      default: null
    },
    allowParticipants: {
      type: Boolean,
      default: true
    },
    allowParticipantGroups: {
      type: Boolean,
      default: true
    },
    groupIdField: {
      type: String,
      default: 'planGroupId'
    },
    groupId: {
      type: [Number, String],
      default: null,
    }
  },
  emits: ['update:modelValue'],
  data() {
    return {
      selectedItems: [],
      organizations: [],
      participants: [],
      participantGroups: [],
      fetched: {},
      loadingOrgs: false,
      loadingParticipants: false,
      loadingGroups: false,
      filterValue: '',
      participantMultiFilter: {
        name: '',
        device: '',
        surname: '',
        shortname: '',
        groupname: '',
        language: ''
      },
      normalizedFilter: normalizeParticipantSelectorFilter(),
      filterSignature: JSON.stringify(normalizeParticipantSelectorFilter()),
      isRecursive: false,
      requestGuard: createParticipantSelectorRequestGuard(),
      debouncedApplyFilter: null,
    }
  },
  created() {
    this.debouncedApplyFilter = debounce(() => {
      this.applyFilterChange()
    }, 300)
  },
  mounted() {
    this.applyFilterChange()
    this.initSelected()
    this.callGetDevices()
  },
  beforeUnmount() {
    this.debouncedApplyFilter?.cancel()
  },
  computed: {
    availableLanguages() {
      return [
        {value: 'ENGLISH', label: this._t('ENGLISH')},
        {value: 'GERMAN', label: this._t('GERMAN')},
        // {value: 'FRENCH', label: this._t('FRENCH')},
        {value: 'ITALIAN', label: this._t('ITALIAN')},
        {value: 'CZECH', label: this._t('CZECH')},
        // {value: 'GREEK', label: this._t('GREEK')},
        // {value: 'SPANISH', label: this._t('SPANISH')}
      ]
    },
    loading() {
      return this.loadingOrgs
          || (this.allowParticipants && this.loadingParticipants)
          || (this.allowParticipantGroups && this.loadingGroups)
    },
    ...mapGetters({
      'getDevices': 'devices/getDevices',
    }),
  },
  watch: {
    participantMultiFilter: {
      deep: true,
      handler() {
        this.debouncedApplyFilter()
      }
    },
  },
  methods: {
    ...mapActions({
      'callGetDevices': 'devices/callGetDevices',
    }),
    nextRequestSequence() {
      return this.requestGuard.next()
    },
    isCurrentRequest(sequence) {
      return this.requestGuard.isCurrent(sequence)
    },
    applyFilterChange() {
      this.initSelected()
      this.normalizedFilter = normalizeParticipantSelectorFilter(this.participantMultiFilter)
      this.filterSignature = JSON.stringify(this.normalizedFilter)
      this.isRecursive = shouldUseRecursiveParticipantSearch(this.normalizedFilter)
      this.initRootOrg(this.nextRequestSequence())
    },
    loadOrg(org, sequence = this.requestGuard.current()) {
      if (org.loadedFilterSignature === this.filterSignature) {
        return
      }

      org.children = []
      org.loadedFilterSignature = this.filterSignature

      if (!this.isRecursive) {
        this.loadOrganizations(org, sequence)
      }
      if (this.allowParticipants && (!this.isRecursive || shouldSearchParticipants(this.normalizedFilter))) {
        this.loadParticipants(org, sequence)
      }
      if (this.allowParticipantGroups && (!this.isRecursive || shouldSearchParticipantGroups(this.normalizedFilter))) {
        this.loadParticipantGroups(org, sequence)
      }

      org.leaf = true
    },
    loadOrganizations(org, sequence) {
      this.loadingOrgs = true
      fetchChildOrganizations(org.data.id).then((response) => {
        if (!this.isCurrentRequest(sequence)) return

        let organizations = response.data
        org.children = org.children.concat(organizations.map((item) => {
          this.fetched['o' + item.id] = item
          return {
            key: 'o' + item.id,
            label: item.name,
            leaf: false,
            children: [],
            icon: 'pi pi-sitemap',
            data: item,
            selectable: false,
            weight: 100,
            type: 'organization'
          }
        }, this))

        org.children.sort(this.sort)

        let manualCallsOrgPos = org.children.findIndex(item => item.label.toLowerCase() === 'manual calls')
        if (manualCallsOrgPos !== -1) {
          let manualCallsOrg = org.children.splice(manualCallsOrgPos, 1)
          let firstOrgPos = org.children.findIndex(item => item.key.startsWith('o'))
          firstOrgPos = firstOrgPos === -1 ? 0 : firstOrgPos
          org.children.splice(firstOrgPos, 0, manualCallsOrg[0])
        }

        this.$forceUpdate()
      }).catch((error) => {
        if (this.isCurrentRequest(sequence)) {
          this.$root.showMessage(formatApiError(error, 'Unable to get participants', 'Unable to get participants: '), 'error')
        }
      }).then(() => {
        if (this.isCurrentRequest(sequence)) {
          this.loadingOrgs = false
        }
      })
    },
    loadParticipants(org, sequence) {
      this.loadingParticipants = true
      const participantFilter = {...this.normalizedFilter}

      if (!participantFilter.device) {
        delete participantFilter.device
      }

      if (this.normalizedFilter.groupname.length !== 0 && !shouldSearchParticipants(this.normalizedFilter)) {
        this.loadingParticipants = false
        return
      }

      fetchParticipants({
        filter: participantFilter,
        orgId: org.data.id,
        recursive: this.isRecursive,
        filterValue: this.filterValue,
      }).then((response) => {
        if (!this.isCurrentRequest(sequence)) return

        org.children = org.children.concat(response.data.list.map((item) => {
          this.fetched['p' + item.id] = item
          return {
            key: 'p' + item.id,
            label: `${item.name} ${item.surname} ${item.shortName ? `(${item.shortName})` : ''}`,
            leaf: true,
            icon: 'pi pi-user',
            data: item,
            selectable: true,
            weight: 10,
            type: 'participant'
          }
        }, this))
        org.children.sort(this.sort)
        this.$forceUpdate()
      }).catch((error) => {
        if (this.isCurrentRequest(sequence)) {
          this.$root.showMessage(formatApiError(error, 'Unable to get participants', 'Unable to get participants: '), 'error')
        }
      }).then(() => {
        if (this.isCurrentRequest(sequence)) {
          this.loadingParticipants = false
        }
      })
    },
    loadParticipantGroups(org, sequence) {
      this.loadingGroups = true
      if (!shouldSearchParticipantGroups(this.normalizedFilter) && this.isRecursive) {
        this.loadingGroups = false
        return
      }

      fetchParticipantGroups({
        groupname: this.normalizedFilter.groupname,
        orgId: org.data.id,
        recursive: this.isRecursive,
      }).then((response) => {
        if (!this.isCurrentRequest(sequence)) return

        org.children = org.children.concat(response.data.list.map((item) => {
          this.fetched['g' + item.id] = item
          return {
            key: 'g' + item.id,
            label: item.name,
            leaf: true,
            icon: 'pi pi-users',
            data: item,
            id: item.id,
            selectable: true,
            weight: 50,
            type: 'group'
          }
        }, this))
        org.children.sort(this.sort)
        this.$forceUpdate()
      }).catch((error) => {
        if (this.isCurrentRequest(sequence)) {
          this.$root.showMessage(formatApiError(error, 'Unable to get participant groups', 'Unable to get participant groups: '), 'error')
        }
      }).then(() => {
        if (this.isCurrentRequest(sequence)) {
          this.loadingGroups = false
        }
      })
    },
    nodeExpand(node) {
      if (!node.leaf) {
        this.loadOrg(node)
      }
    },
    nodeSelect() {
      this.selectParticipants()
    },
    nodeUnselect() {
      this.selectParticipants()
    },
    initRootOrg(sequence = this.nextRequestSequence()) {
      this.loadingOrgs = true
      fetchRootOrganizations(this.orgId).then((response) => {
        if (!this.isCurrentRequest(sequence)) return

        this.organizations = response.data.list.map((item) => {
          this.fetched['o' + item.id] = item
          return {
            key: 'o' + item.id,
            label: item.name,
            leaf: false,
            children: [],
            icon: 'pi pi-sitemap',
            data: item,
            selectable: false,
            weight: 100,
            type: 'organization'
          }
        }, this)

        if (this.isRecursive) {
          this.organizations.forEach((org) => {
            this.loadOrg(org, sequence)
          })
        }
      }).catch((error) => {
        if (this.isCurrentRequest(sequence)) {
          this.$root.showMessage(formatApiError(error, 'Unable to get organization', 'Unable to get organization: '), 'error')
        }
      }).then(() => {
        if (this.isCurrentRequest(sequence)) {
          this.loadingOrgs = false
        }
      })
    },
    selectParticipants() {
      let members = {}
      let orderBase = this.modelValue?.length ?? 0
      this.modelValue?.forEach((item) => {
        if (item.participantId) {
          if (this.selectedItems['p' + item.participantId]) {
            members['p' + item.participantId] = item
          }
        }
        if (item.participantGroupId) {
          if (this.selectedItems['g' + item.participantGroupId]) {
            members['g' + item.participantGroupId] = item
          }
        }
      }, this)
      Object.keys(this.selectedItems).forEach((item) => {
        if (!item.startsWith('o') && !members[item]) {
          let member = {
            id: '_' + item,
            participantId: null,
            participantGroupId: null,
            orderId: orderBase + Object.keys(members).length
          }
          member[this.groupIdField] = !this.groupId || this.groupId.toString().startsWith('_') ? null : this.groupId

          if (item.startsWith('p')) {
            member['participantId'] = this.fetched[item].id
            member['title'] = this.fetched[item].name + ' ' + this.fetched[item].surname
            member['name'] = this.fetched[item].name + ' ' + this.fetched[item].surname
            member['shortName'] = this.fetched[item].shortName
          }
          if (item.startsWith('g')) {
            member['participantGroupId'] = this.fetched[item].id
            member['title'] = this.fetched[item].name
            member['name'] = this.fetched[item].name
          }

          members[item] = member
        }
      }, this)
      this.$emit('update:modelValue', Object.values(members))
    },
    initSelected() {
      this.selectedItems = {}
      this.modelValue?.forEach((item) => {
        if (item.participantId) {
          this.selectedItems['p' + item.participantId] = {checked: true, partialChecked: false}
        }
        if (item.participantGroupId) {
          this.selectedItems['g' + item.participantGroupId] = {checked: true, partialChecked: false}
        }
        if (item.orgId) {
          this.selectedItems['o' + item.orgId] = {checked: false, partialChecked: true}
        }
      }, this)
    },
    sort(a, b) {
      if (a.weight === b.weight) {
        return a.label.toLocaleLowerCase().localeCompare(b.label.toLocaleLowerCase())
      } else {
        return a.weight < b.weight ? -1 : 1
      }
    }
  }
}
</script>
<style lang="scss" scoped>
::v-deep(.p-accordion-toggle-icon) {
  padding-left: 10px;
}
</style>
